<template>
  <div class="chat-details-wrap">

    <!-- chat-details start -->
    <div class="chat-details" ref="feed">

      <div class="message-time">
        <p>Fri, 5 Dec 19</p>
      </div>
      <!-- message time -->

      <div v-for="(msg, index) in messages" class="mb-2 inner-chat-details" :key="index">
        <div class="d-flex" :class="`${msg.id != 1 ? 'msg-left' : 'msg-right'}`">
          <div class="img_cont_msg">
            <img src="../../assets/images/chat-user1.png" alt="user" v-if="msg.id!=1">
            <img src="../../assets/images/f3.png" alt="user" v-else>
          </div> 
          <div class="msg-content">
            <div class="msg_cotainer" style="white-space: pre-wrap;">
              {{msg.body}}
            </div> 
            <span class="msg_time">08:43 am</span>
          </div>
        </div>
        <div class="message-time" :class="`${ index < messages.length-1 && messages[index+1].date == messages[index].date ? 'hide-time' : ''}`">
          <p>{{ msg.date | dateFormat}}</p>
        </div>
      </div> <!-- /.msg-left -->

    </div>
    <!-- chat-details end -->

    <!-- send message start -->
    <div class="writeMsg" v-if="!isBlockUser()">
      <div class="msgArea">
        <TextareaAutosize
        placeholder="Type something here..."
        v-model="message"
        :min-height="textarea.minHeight"
        :max-height="textarea.maxHeight"
        @keydown.enter.native="inputHandler"
      />
        <button type="submit" @click="send">
          <img src="../../assets/icon/Send-Button.svg" alt="Send-Button" />
        </button>
      </div>
      <div class="rcvUser">
          <img src="../../assets/images/f3.png" alt="user">
      </div>
    </div>
    <div class="writeMsg" v-else>
      <div class="msgArea">
        <textarea disabled  placeholder="You cannot send a message to blocked user" style="background: #fff"></textarea>
        <button class="unblock-user" type="submit" @click="unBlock">
          Unblock
        </button>
      </div>
    </div>
    <!-- send message start -->

  </div>
</template>

<script>

  import { EventBus } from '../../main';
  import moment from 'moment';
  export default {

      name: "direct-chat-details",
      
      data() {
          return {

            message:'',
            messages: [
              {
                body: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat nonproident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                id:2,
                date: 'Tuesday, February 25, 2020 2:00 AM'
              },
              {
                body: 'Lorem ipsum dolor sit amet',
                id:1,
                date: 'Tuesday, February 25, 2020 2:10 AM'
              },
              {
                body: 'Lorem ipsum dolor sit amet',
                id:2,
                date: 'Tuesday, February 25, 2020 2:37 AM'
              },
              {
                body: 'Lorem ipsum dolor sit amet',
                id:2,
                date: 'Tuesday, February 25, 2020 2:37 AM'
              },
            ],

            blockUsers:[],
            window: {
              width: 0
            },
            textarea: {
              minHeight:0,
              maxHeight: 0,
            }
          }
      },

      methods: {
        inputHandler(e) {
          console.log(e);
          if(this.window.width > 768) {
            if(e.keyCode === 13 && !e.shiftKey) {
                e.preventDefault();
                this.send();
            } 
          }

        },

        viewBlockUser() {
          if(localStorage.getItem('blockedUsers')){
            this.blockUsers = JSON.parse(localStorage.getItem('blockedUsers'));
          }
        },

        blockUser(){
          let parsed = JSON.stringify(this.blockUsers);
          localStorage.setItem('blockedUsers',parsed);
          this.viewBlockUser();
        },

        isBlockUser() {
          if(this.blockUsers.length>0) {
            for (var i = 0; i < this.blockUsers.length; i++) {
              if(this.blockUsers[i]==this.$route.params.id) {
                return true;
              } 
            }
          }
          return false;
        },

        unBlock() {
          if(this.blockUsers.length>0) {
            for (var i = 0; i < this.blockUsers.length; i++) {
              if(this.blockUsers[i]==this.$route.params.id) {
                this.blockUsers.splice(i,1);
              } 
            }
          }
          this.blockUser();
          this.isBlockUser();

          EventBus.$emit('unBlockUsers', this.blockUsers);
        },

        send() {
          
          if(this.message!='') {
            this.messages.push({body:this.message, id:1, date:moment().format('LLLL')})
            this.message='';
            this.scrollToBottom();
          }
        },

        scrollToBottom() {
          setTimeout(()=>{
            this.$refs.feed.scrollTop = this.$refs.feed.scrollHeight - this.$refs.feed.clientHeight;
          },50);
        },


        // get device size
        handleResize() {
          this.window.width = window.innerWidth;
          if(this.window.width <= 768){
            this.textarea.minHeight=30;
            this.textarea.maxHeight=80;
          } else {
            this.textarea.minHeight=30;
            this.textarea.maxHeight=50;
          }
        }

      },

      destroyed() {
          window.removeEventListener('resize', this.handleResize)
      },

      mounted() {
         EventBus.$on('blockUsers', data => {
           this.blockUsers=data;
           this.viewBlockUser();
           this.isBlockUser();  
         });
         window.addEventListener('resize', this.handleResize)
         this.handleResize();
      },



  }
</script>

<style>
  @import '../../assets/css/direct-chat-details.css';
</style>